<template>
  <table class="attendance table-bordered">
    <tr
      style="width:100%"
      v-bind:class="{ green: key % 2 === 0 }"
      v-for="(value, key) in tableData.label"
      :key="uniqueId(titleKey + key)"
      :title="value"
    >
      <td width="80%">
        <div v-if="!clickAble" :title="value">
          {{ value }}
        </div>
        <div v-else class="clicked" @click="showDetail(key)">{{ value }}</div>
      </td>

      <td width="20%" class="text-right">
        {{ formatPrice(tableData.data[key]) }}
      </td>
    </tr>
  </table>
</template>

<script>
import _ from "lodash";

export default {
  name: "table-total",
  props: {
    tableData: {
      type: [Array, Object],
      default: () => []
    },
    titleKey: {
      type: String,
      default: ""
    },
    clickAble: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    showDetail: function(row) {
      this.$emit("showDetail", row);
    }
  }
};
</script>
